export default function CheckmarkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
    >
      <path
        d="M12.5 18L16.302 21.4218C16.9493 22.0043 17.9549 21.9151 18.4895 21.2278L24.5 13.5M18.5 33C26.7843 33 33.5 26.2843 33.5 18C33.5 9.71573 26.7843 3 18.5 3C10.2157 3 3.5 9.71573 3.5 18C3.5 26.2843 10.2157 33 18.5 33Z"
        stroke="#11A75C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
